"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgNetworkOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 20a4 4 0 00-3.86 3H17V9h3.14a4 4 0 100-2H15v8h-3.14a4 4 0 100 2H15v8h5.14A4 4 0 1024 20zm0-14a2 2 0 11-2 2 2 2 0 012-2zM8 18a2 2 0 112-2 2 2 0 01-2 2zm16 8a2 2 0 112-2 2 2 0 01-2 2z" })));
}
exports.default = SvgNetworkOutline;
//# sourceMappingURL=NetworkOutline.js.map